import { Avatar, CardActionArea, Typography } from '@mui/material'

import { useStyles } from './styles'

interface IProps {
  image?: string
  title: string
  subtitle?: string | null
  onClick?: () => void
  label?: string
}

export const Item = ({ onClick, image, title, subtitle, label }: IProps) => {
  const classes = useStyles()

  return (
    <div>
      <Typography className={classes.itemlabel}>{label}&nbsp;</Typography>
      <CardActionArea onClick={onClick} className={classes.item}>
        {image && <Avatar className={classes.itemImage} src={image} alt={title} />}
        <div>
          <Typography className={classes.itemTitle}>{title}</Typography>
          {subtitle && (
            <Typography className={classes.itemSubtitle} variant="subtitle2">
              {subtitle}
            </Typography>
          )}
        </div>
      </CardActionArea>
    </div>
  )
}
